import styled from 'styled-components'
import variables, { colors, device } from 'Styled/variables'

export const AlertBlock = styled.div`
  background: ${colors.white};
  padding: 16px 23px 16px 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  @media ${device.mobileMin} {
    background: ${colors.errorBg};
    margin-bottom: 3px;
  }
`
export const TextIconBlock = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`

export const AlertIcon = styled.div`
  display: flex;
  margin-right: 8px;
  padding-top: 4px;
  & img {
    width: 16px;
    height: 14.14px;
  }
`
export const AlertText = styled.div`
  font-size: ${variables.fontSize14};
  line-height: 21px;
  font-weight: 600;
  color: ${colors.mainText};
`

export const AlertClose = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0px 0px 0px 23px;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  & img {
    width: 10px;
    height: 10px;
  }
`
